import React from 'react';
import { useSearchParams } from 'react-router-dom';
import spottoLogo from '../assets/spotto-logo.png';

export const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get payment details from URL parameters
  const reservationId = searchParams.get('reservationId');
  const amount = searchParams.get('amount');
  const paymentId = searchParams.get('paymentId');

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="bg-zinc-900 rounded-xl border border-zinc-800 p-8 max-w-lg w-full text-center shadow-2xl">
        
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={spottoLogo} 
            alt="Spotto.pl" 
            className="h-16 mx-auto mb-4"
          />
        </div>

        {/* Success Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg 
              className="w-12 h-12 text-green-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-2">
            Płatność Zakończona Sukcesem!
          </h1>
          
          <p className="text-zinc-400 text-lg">
            Dziękujemy za dokonanie płatności
          </p>
        </div>

        {/* Payment Details */}
        <div className="bg-zinc-800 rounded-lg p-6 mb-8 text-left">
          <h2 className="text-lg font-semibold text-white mb-4">
            Szczegóły Płatności
          </h2>
          
          <div className="space-y-3">
            {reservationId && (
              <div className="flex justify-between items-center">
                <span className="text-zinc-400">Numer Rezerwacji:</span>
                <span className="text-white font-mono text-sm">#{reservationId}</span>
              </div>
            )}
            
            {amount && (
              <div className="flex justify-between items-center">
                <span className="text-zinc-400">Kwota:</span>
                <span className="text-white font-semibold">{amount} PLN</span>
              </div>
            )}
            
            {paymentId && (
              <div className="flex justify-between items-center">
                <span className="text-zinc-400">ID Transakcji:</span>
                <span className="text-white font-mono text-xs">{paymentId}</span>
              </div>
            )}
            
            <div className="flex justify-between items-center">
              <span className="text-zinc-400">Status:</span>
              <span className="text-green-400 font-semibold">
                ✓ Opłacono
              </span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-zinc-400">Data:</span>
              <span className="text-white">
                {new Date().toLocaleDateString('pl-PL', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
          </div>
        </div>

        {/* Next Steps */}
        <div className="mb-8">
          <h3 className="text-lg font-semibold text-white mb-4">
            Co dalej?
          </h3>
          
          <div className="text-zinc-300 space-y-2 text-sm">
            <p>• Potwierdzenie płatności zostanie wysłane na Twój e-mail</p>
            <p>• Możesz zarządzać swoimi rezerwacjami w panelu klienta</p>
            <p>• W przypadku pytań, skontaktuj się z naszym zespołem</p>
          </div>
        </div>


        {/* Contact Info */}
        <div className="mt-8 pt-6 border-t border-zinc-800">
          <p className="text-zinc-400 text-sm mb-2">
            Masz pytania? Skontaktuj się z nami:
          </p>
          <div className="text-zinc-300 text-sm">
            <p>📧 kontakt@spotto.pl</p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-zinc-600 text-xs">
          <p>&copy; 2024 Spotto.pl - Wszystkie prawa zastrzeżone</p>
        </div>
      </div>
    </div>
  );
};